const fontSizes = {
    xs: { value: "12px" },
    sm: { value: "14px" },
    md: { value: "16px" },
    lg: { value: "18px" },
    xl: { value: "20px" },
    "2xl": { value: "24px" },
    "3xl": { value: "28px" },
    "4xl": { value: "36px" },
    "5xl": { value: "48px" },
    "6xl": { value: "64px" },
}

export default fontSizes
